// extracted by mini-css-extract-plugin
export default {"accessoryButton":"WithCommentIconButtonWithTooltip_accessoryButton__o+zs4"};